import ConfigsModule from '../../../configs/configs';
import ResourcesModule from '../../../resources/resources';
import template from './usersForm.jade';
import Services from '../../../services/services';
import qrcode from 'qrcode-generator';
import {isAllNumbers} from "../../../common/util/validation-util";
import {hasStaleLogin} from './userStatus.util';

export class UsersFormController {
  /* @ngInject */
  constructor(currentUser, rolesOptions, $http, api) {
    console.log(this.resource);
    this.currentUser = currentUser;
    this.currentUserValue = this.currentUser && this.currentUser.value;
    this.rolesOptions = _.cloneDeep(rolesOptions);
    if (this.currentUser.value.hasRole('OPERATION_MANAGER')) {
      const allowed = ['GD_ACCOUNT_MANAGER', 'AGENCY', 'ADMIN_AGENCY'];
      this.rolesOptions = this.rolesOptions.filter(role => allowed.includes(role.value));
    }

    this.passwordInputFields = [
      {
        className: 'layout__item u-4/12',
        type: 'input',
        key: 'password',
        expressionProperties: {
          "templateOptions.label": "'password' | translate"
        },
        templateOptions: {
          label: '',
          required: true,
          type: 'password'
        }
      },
      {
        className: 'layout__item u-4/12',
        type: 'input',
        key: 'password_confirmation',
        expressionProperties: {
          "templateOptions.label": "'password_confirmation' | translate"
        },
        templateOptions: {
          label: '',
          required: true,
          type: 'password'
        },
        extras: {validateOnModelChange: true},
        validators: {
          passwordConfirmation: {
            expression: function ($viewValue, $modelValue, scope) {
              let value = $modelValue || $viewValue;
              return value == scope.model.password;
            },
            message: 'password confirmation does not match'
          }
        }
      }
    ];

    this.showPasswordButtonField = {
      className: 'layout__item u-8/12',
      key: 'change_password_button',
      template: `<a class="o-btn c-btn c-btn--small c-btn--outlined" id='change-password' ng-click="to.onClick($event)">{{ 'change_password' | translate }}</a>`,
      templateOptions: {
        onClick: (event => {
          this.showPassword();
          this.showCancelPasswordButton();
        })
      }
    };

    this.cancelPasswordButtonField = {
      className: 'layout__item u-8/12',
      key: 'cancel_change_password_button',
      template: `<a class="o-btn c-btn c-btn--small c-btn--outlined" id='change-password' ng-click="to.onClick($event)">{{ 'cancel' | translateWith:'change_password' }}</a>`,
      templateOptions: {
        onClick: (event => this.hidePassword())
      }
    };

    this.fields = [
      {
        className: 'layout__item u-6/12',
        type: 'input',
        key: 'first_name',
        expressionProperties: {
          "templateOptions.label": "'first_name' | translate",
          'templateOptions.disabled': () => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER']),
        },
        templateOptions: {
          label: '',
          required: true
        }
      },
      {
        className: 'layout__item u-6/12',
        type: 'input',
        key: 'last_name',
        expressionProperties: {
          "templateOptions.label": "'last_name' | translate",
          'templateOptions.disabled': () => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER']),
        },
        templateOptions: {
          label: '',
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'email',
        expressionProperties: {
          "templateOptions.label": "'email' | translate",
          'templateOptions.disabled': () => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER']),
        },
        templateOptions: {
          label: '',
          required: true,
          type: 'email'
        }
      },
      {
        className: 'layout__item u-1/1',
        hideExpression: 'model.role !== "APP_DEVELOPER" && model.role !== "ADMIN" && model.role !== "OPERATION_MANAGER"',
        expressionProperties: {
          "templateOptions.label": "'send_emails' | translate"
        },
        type: 'checkbox',
        key: 'send_emails',
      },
      {
        className: 'layout__item u-4/12',
        key: 'status_display',
        templateOptions: {
          statusOptions: {
            'Active': 'Active',
            'Inactive': 'Inactive',
            'PendingApproval': 'Pending Approval'
          },
          statusColors: {
            'Active': 'green',
            'Inactive': 'red',
            'PendingApproval': '#b8860b'
          },
        },
        template: `
          <div class="formly-field" style="display: flex; align-items: center;">
            <label class="c-label" style="margin-right: 8px;">
              {{ 'status' | translate }}:
            </label>
            <span ng-style="{ color: to.statusColors[model.status] || 'black' }">
              {{ to.statusOptions[model.status] || 'Unknown' }}
            </span>
          </div>
        `
      },
      {
        className: 'layout__item u-1/1',
        key: 'reactivate_user',
        type: 'checkbox',
        hideExpression: (view, model, scope) => {
          return !this.shouldShowReactivateControl(scope && scope.model);
        },
        expressionProperties: {
          "templateOptions.label": "'Reactivate User'"
        },
        templateOptions: {
          required: false
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'approve_user',
        type: 'checkbox',
        hideExpression: (view, model, scope) => {
          if (!this.originalStatus && scope.model && scope.model.status) {
            this.originalStatus = scope.model.status;
          }

          const isAdmin = this.currentUser.value.hasRole('ADMIN');
          return this.originalStatus !== "PendingApproval" || !isAdmin;
        },
        expressionProperties: {
          "templateOptions.label": "'approve_user' | translate",
          "templateOptions.help": "'approve_user_help' | translate",
          "templateOptions.helpTextPlacement": "'right'",
        },
        templateOptions: {
          required: false,
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'use_mfa',
        type: 'checkbox',
        expressionProperties: {
          "templateOptions.label": "'mfa' | translate",
          "templateOptions.disabled": 'true',
          "templateOptions.help": "'mfa_help' | translate",
          "templateOptions.helpTextPlacement": "'right'"
        },
        templateOptions: {
          required: false
        }
      },
      {
        className: 'layout__item u-4/12',
        key: 'role',
        type: 'uiSelect',
        expressionProperties: {
          "templateOptions.label": "'role' | translate"
        },
        templateOptions: {
          label: '',
          options: this.rolesOptions,
          onChange: (($newValue, $model, $scope) => {
            if ($scope && !_.includes(['APP_DEVELOPER', 'SELLER_ONLY', 'BUYER_ONLY'], $newValue )) {
              delete $scope.model.game_developer_ids;
            }
            if ($scope && $newValue !== 'OPERATION_MANAGER') {
              delete $scope.model.allow_all_app_developers;
            }
          })
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'uiSelect',
        key: 'game_developer_ids',
        hideExpression: 'model.role !== "APP_DEVELOPER" && model.role !== "GD_ACCOUNT_MANAGER" && model.role !== "SELLER_ONLY" && model.role !== "BUYER_ONLY"',
        expressionProperties: {
          "templateOptions.label": "'gameDeveloper' | translate"
        },
        templateOptions: {
          label: '',
          options: [
            {id: '', company_name: ''}
          ],
          valueProp: 'id',
          labelProp: 'company_name'
        },
        controller: /* @ngInject */ function ($scope, GameDevelopersResource) {
          $scope.to.loading = GameDevelopersResource.getList()
            .then(function (response) {
              $scope.to.options = response;
              return response;
            });
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'uiSelectMultiple',
        key: 'game_developer_ids',
        hideExpression: 'model.role !== "AGENCY" && model.role !== "ADMIN_AGENCY" && model.role !== "OPERATION_MANAGER"',
        expressionProperties: {
          "templateOptions.label": "'gameDevelopers' | translate",
          "templateOptions.disabled": 'model.role === "OPERATION_MANAGER" && model.allow_all_app_developers === true'
        },
        templateOptions: {
          label: '',
          options: [
            {id: '', company_name: ''}
          ],
          valueProp: 'id',
          labelProp: 'company_name'
        },
        controller: /* @ngInject */ function ($scope, GameDevelopersResource) {
          $scope.to.loading = GameDevelopersResource.getList()
            .then(function (response) {
              $scope.to.options = response;
              return response;
            });
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'allow_all_app_developers',
        type: 'checkbox',
        hideExpression: 'model.role !== "OPERATION_MANAGER"',
        expressionProperties: {
          "templateOptions.label": "'All Apps'"
        },
        templateOptions: {
          required: false,
          onChange: (($newValue, $model, $scope) => {
            if ($newValue && $scope) {
              delete $scope.model.game_developer_ids;
            }
          })
        }
      },
    ];

    this.configureForm();
  }

  configureForm() {
    this.removeField('change_password_button');

    if (this.resource && !this.resource.id) {
      this.showPassword();
    } else {
      this.showPasswordButton();
    }

    if (this.accountSettings) {
      this.removeField('role');
      this.removeField('game_developer_ids');
      this.removeField('allow_all_app_developers');
    }

    this.currentUser.subscribe((user) => {
      if(user) {
        this.currentUserValue = user;
        this.initialUseMfa = user.use_mfa;
        this.isMfaToggled = user.isMfaToggled;
        if (!user.hasRole('ADMIN')) {
          this.removeRole('ADMIN');
        }
      }
    });

  }

  getLastUiComponentIndex() {
    let insertAt = _.findIndex(this.fields, {key: 'mfa_code'});
    if (insertAt === -1) {
      insertAt = _.findIndex(this.fields, {key: 'show-qr'});
    }

    return insertAt;
  }

  showPassword() {
    this.removeField('change_password_button');
    let insertAt = this.getLastUiComponentIndex() + 1;
    Array.prototype.splice.apply(this.fields, [insertAt, 0].concat(this.passwordInputFields));
  }

  hidePassword() {
    this.removeField('password');
    this.removeField('password_confirmation');
    this.removeField('cancel_change_password_button');
    this.showPasswordButton();
  }

  showPasswordButton() {
    let insertAt = this.getLastUiComponentIndex() + 1;
    Array.prototype.splice.apply(this.fields, [insertAt, 0].concat([this.showPasswordButtonField]));
  }

  showCancelPasswordButton() {
    let insertAt = this.getLastUiComponentIndex() + (this.accountSettings ? 3 : 4);
    Array.prototype.splice.apply(this.fields, [insertAt, 0].concat([this.cancelPasswordButtonField]));
  }

  shouldShowReactivateControl(model) {
    const currentUser = this.currentUserValue;
    const hasPermission = currentUser && currentUser.hasRole && currentUser.hasRole('ADMIN');
    const hasExistingUser = model && model.id;
    const staleLogin = hasStaleLogin(model);

    return hasPermission && hasExistingUser && staleLogin;
  }

  removeField(key) {
    _.remove(this.fields, (field => field.key == key));
  }

  removeRole(role) {
    _.remove(this.rolesOptions, (field => field.value == role));
  }
}

export function UsersFormComponent() {
  return {
    template,
    controller: UsersFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      resource: '=',
      accountSettings: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.users.form', [
  ConfigsModule.name,
  ResourcesModule.name,
  Services.name
])
.directive('adminUsersForm', UsersFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/users/usersForm.js
 **/